import React from "react";
import MarketOverviewTable from "../MarketOverviewTable";
import { useMarketOverviewData } from "../../../context/MarketOverviewContext";
import { DEFAULT_CATALYSTS } from "../../../constants/sections";

const CommoditiesTab = () => {
    const { rows } = useMarketOverviewData();
    const data = rows.filter(row => (row.category || row.Category) === "Commodities");
    const COMMODITIES_ORDER = ["XAUUSD", "XAGUSD", "USOIL"];
    return <MarketOverviewTable data={data} title="Commodities Analysis" defaultRowData={{ Category: "Commodities" }} defaultCatalysts={DEFAULT_CATALYSTS.Commodities} customSortOrder={COMMODITIES_ORDER} />;
};

export default CommoditiesTab;
